<mat-card *ngIf="card.display == 'Summary'" style="min-height: 115px; max-height: 115px; display: flex; flex-direction: row; cursor: pointer; padding: 0" (click)="cardClick()">
  <div [ngClass]="isDisabled()" style="display: flex; flex-direction: column; flex: .25;">
    <img *ngIf="!card.disabled" style="display: block; margin: auto; height: 90px; max-width: 90px;" src="./assets/images/Card Meal Service.png">
    <img *ngIf="card.disabled" style="display: block; margin: auto; height: 90px; max-width: 90px;" src="./assets/images/Card Meal Service disabled.png">
  </div>
  <div style="display: flex; flex-direction: column; flex: 1;">
    <div class="robotoMedium" style="display: flex; flex-direction: row; padding: 5px; flex: .25; font-size: 12pt; align-items: flex-start;">
        <span translate>Meal Service Balance</span>
    </div>
    <div *ngIf="!card.disabled" class="robotoBold" [ngClass]="checkIfNegative(balance)" style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 22pt; padding-bottom: 10px;">
      <div style="padding: 5px;">
        {{absBalance | currency}}
      </div>
      <div style="padding: 5px;" *ngIf="balance < 0">
          <span translate>Overdrawn</span>
      </div>
    </div>
    <!--If Disabled-->
    <div *ngIf="card.disabled" class="robotoMedium" style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
      <div>
        {{card.disabledMessage}}
      </div>
    </div>
  </div>
</mat-card>
<mat-card *ngIf="card.display == 'Detail'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
  <div style="display: flex; flex-direction: column; flex: 1">
    <div [ngClass]="isDisabled()" style="display: flex; flex-direction: row;">
      <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
          <span translate>Meal Service Balance</span>
      </div>
      <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; padding: 5px">
        <div *ngIf="!v10" style="display: flex; flex-direction: column; flex: 1; align-items: flex-start; margin-right: 5px;">
          <button *ngIf="userType==2 && showPay == true " [disabled]="card.disabled" mat-stroked-button class="mat-card-button" (click)="payClick()">
              <span translate>Pay</span>
          </button>
        </div>
        <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end;">
          <button mat-stroked-button class="mat-card-button" (click)="viewDetailsClick()"><span translate>Go To Meal Service</span></button>
        </div>
      </div>
    </div>
    <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; flex: 1">
      <mat-list style="display: flex;flex-direction: column;flex: 1;" role="list">
        <mat-list-item role="listitem" *ngIf="rolloverBalance > 0">
          <div style="display: flex; flex-direction: row; flex: 1;">
            <div style="display: flex; flex: 1;" translate>Rollover Balance</div>
            <div>{{rolloverBalance | number: '1.2'}}</div>
          </div>
          <mat-divider></mat-divider>
        </mat-list-item>
        <mat-list-item role="listitem">
          <div style="display: flex; flex-direction: row; flex: 1;">
            <div style="display: flex; flex: 1;" translate>Deposits</div>
            <div>{{deposits | number: '1.2'}}</div>
          </div>
          <mat-divider></mat-divider>
        </mat-list-item>
        <mat-list-item role="listitem">
          <div style="display: flex; flex-direction: row; flex: 1;">
            <div style="display: flex; flex: 1;" translate>Charges</div>
            <div>{{charges | number: '1.2'}}</div>
            <mat-divider></mat-divider>
          </div>
        </mat-list-item>
        <mat-list-item role="listitem">
          <div style="display: flex; flex-direction: row; flex: 1;">
            <div style="display: flex; flex: 1; justify-content: flex-end; padding-right: 10px;font-weight:bold;" translate>Balance</div>
            <div style="display: flex" [ngClass]="checkIfNegative(balance)">
              <div>
                {{absBalance | currency}}
              </div>
              <div style="padding-left: 5px" *ngIf="balance < 0">
                  <span translate>Overdrawn</span>
              </div>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
    <!--If Disabled-->
    <div *ngIf="card.disabled" class="robotoMedium" style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
      <div style="padding: 50px;">
        {{card.disabledMessage}}
      </div>
    </div>
  </div>
</mat-card>
